const parseTime = (t) => {
    const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(t);
    if (!m)
        return null;
    return Number(m[1]) * 60 + Number(m[2]);
};
// BE floors: mark/validation.py:_validate_send_window — email 08:00-21:00,
// SMS 10:00-20:00; mixed drips must overlap both channel floors.
export const getSendWindowErrors = (hasEmail, hasSms, sendWindowStart, sendWindowEnd) => {
    const errors = [];
    const hasOneWindow = Boolean(sendWindowStart) !== Boolean(sendWindowEnd);
    if (hasOneWindow) {
        errors.push('Send window must have both start and end, or neither.');
        return errors;
    }
    if (!sendWindowStart || !sendWindowEnd)
        return errors;
    const start = parseTime(sendWindowStart);
    const end = parseTime(sendWindowEnd);
    if (start == null || end == null) {
        errors.push('Send window times must be HH:MM (24-hour).');
        return errors;
    }
    if (start >= end) {
        errors.push('Send window start must be before end.');
    }
    const mixed = hasEmail && hasSms;
    if (mixed) {
        if (!(start < 1260 && 480 < end)) {
            errors.push('Send window must overlap 08:00–21:00 for email activities.');
        }
        if (!(start < 1200 && 600 < end)) {
            errors.push('Send window must overlap 10:00–20:00 for SMS activities.');
        }
    }
    else {
        if (hasEmail && (start < 480 || end > 1260)) {
            errors.push('Send window must be within 08:00–21:00 for email activities.');
        }
        if (hasSms && (start < 600 || end > 1200)) {
            errors.push('Send window must be within 10:00–20:00 for SMS activities.');
        }
    }
    return errors;
};
